<template src="../templates/searchBookingFilter.html"></template>

<script>
    export default {
        name: "SearchBookingFilter",
        props: ["searchModel"],
        methods: {
            loadInterpreters: function (filterByState = true) {
                if (this.searchModel.language != null && this.language !== "") {
                    let url = this.$localApiURL + "interpreters/get/" + this.searchModel.language + "/" + filterByState.toString();
                    let localThis = this;
                    this.$http.get(url, {
                        headers: {"Bearer": localStorage.getItem("jwt")}
                    }).then(function (response) {
                        //
                        localThis.interpreters = response.data;
                        localThis.interpretersTemp = response.data;

                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            loadLanguages: function () {
                let url = this.$localApiURL + "languages/get";
                let localThis = this;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {
                    localThis.languages = response.data;
                    localThis.languagesTemp = response.data;

                }).catch(function (error) {
                    console.log(error);
                });
            }, filterLanguages(query) {

                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.languages = this.languagesTemp.filter(item => {
                            if (item != null && item.language != null) {
                                return item.language.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            }
                            return false;
                        });
                    }, 200);
                } else {
                    this.languages = [];
                }
                
            },filterInterpreters(query) {

                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.interpreters = this.interpretersTemp.filter(item => {
                            if (item != null && item.interpreterName != null) {
                                return item.interpreterName.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            }
                            return false;
                        });
                    }, 200);
                } else {
                    this.interpreters = [];
                }
            },
        },
        created() {
            this.loadLanguages();
        },
        data() {
            return {
                languages: [],
                languagesTemp:[],
                interpreters: [],
                interpretersTemp:[],
                loading: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SearchBookingFilter.vue